import { Fragment } from "react";

import { ChartsReferenceLine as MuiChartsReferenceLine, useXScale } from "@mui/x-charts";
import { Box } from "@mui/material";

import { SPACING, useAppPalette } from "../../theme";
import { ChartsReference } from "./types";
import { Text } from "../typography";
import { Tooltip } from "../misc";
import { Icon } from "../icons";

export default function ChartsReferences({ references }: { references: ChartsReference[] | undefined }) {
    return (
        <Fragment>
            {references?.map((r, i) => (
                <ChartsReferenceLine {...r} key={i} />
            ))}
        </Fragment>
    );
}

function ChartsReferenceLine({ date }: ChartsReference) {
    return <MuiChartsReferenceLine x={date} />;
}

export function ChartsReferencesLabels({ references }: { references: ChartsReference[] | undefined }) {
    return (
        <Fragment>
            {references?.map((r, i) => (
                <ChartsReferenceLabel x={r.date} label={r.label} key={i} showIcon={r.type === "line"} />
            ))}
        </Fragment>
    );
}

function ChartsReferenceLabel({
    x,
    y,
    label,
    showIcon
}: {
    x: number;
    y?: number;
    label?: string;
    showIcon?: boolean;
}) {
    const { divider, background, cardBackground } = useAppPalette();
    const xAxisScale = useXScale();

    const left = xAxisScale(x) ?? 0;

    return (
        <Box
            sx={{
                position: "absolute",
                left,
                bottom: SPACING * 4,
                translate: "-50% 0%",
                backgroundColor: background,
                borderRadius: 1000
            }}
        >
            <Box
                sx={{
                    backgroundColor: divider,
                    borderRadius: 1000,
                    padding: 0.5,
                    border: `1px solid ${cardBackground}`
                }}
            >
                <Tooltip title={label} placement="right">
                    <Text variant="caption" color="caption">
                        {showIcon && <Icon type="date" />}
                    </Text>
                </Tooltip>
            </Box>
        </Box>
    );
}
